import { HERO } from "../data/siteData";
import { ArrowRight, Sparkles } from "lucide-react";

const go = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Hero = () => {
  return (
    <section id="inicio" className="relative min-h-screen flex items-center pt-20 overflow-hidden" data-testid="hero-section">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO.background}
          alt="AURA Spa"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-overlay"></div>
      </div>

      {/* Decorative gold rings */}
      <div className="absolute -right-32 top-40 w-96 h-96 rounded-full border border-gold/20 hidden md:block" aria-hidden="true"></div>
      <div className="absolute -right-20 top-60 w-72 h-72 rounded-full border border-gold/10 hidden md:block" aria-hidden="true"></div>

      <div className="container-aura relative z-10 grid lg:grid-cols-12 gap-12 items-center w-full">
        <div className="lg:col-span-7 animate-fade-up">
          {/* Eyebrow */}
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-1.5 rounded-full bg-white/60 backdrop-blur-sm border border-beige-200">
            <Sparkles size={14} className="text-gold" />
            <span className="text-xs tracking-luxe uppercase text-ink-soft">Centro de Estética Premium</span>
          </div>

          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl text-ink leading-[1.05] tracking-tight">
            <span className="block">AURA</span>
            <span className="block text-2xl sm:text-3xl lg:text-4xl mt-2 text-ink-soft font-serif italic">
              Estética Corporal & Spa
            </span>
          </h1>

          <div className="gold-divider my-8"></div>

          <p className="text-lg md:text-xl text-ink-soft max-w-xl leading-relaxed mb-10 font-light">
            {HERO.subtitle}
          </p>

          <div className="flex flex-wrap items-center gap-4">
            <button
              onClick={() => go("reservas")}
              className="btn-gold group"
              data-testid="hero-cta-reserve"
            >
              Reservar cita
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </button>
            <button
              onClick={() => go("servicios")}
              className="btn-outline-gold"
              data-testid="hero-cta-services"
            >
              Ver servicios
            </button>
          </div>

          {/* Stats row */}
          <div className="mt-16 grid grid-cols-3 gap-4 max-w-md">
            <div>
              <div className="font-serif text-3xl md:text-4xl text-gold">+500</div>
              <div className="text-xs tracking-luxe uppercase text-ink-soft mt-1">Clientes felices</div>
            </div>
            <div>
              <div className="font-serif text-3xl md:text-4xl text-gold">+20</div>
              <div className="text-xs tracking-luxe uppercase text-ink-soft mt-1">Tratamientos</div>
            </div>
            <div>
              <div className="font-serif text-3xl md:text-4xl text-gold">5★</div>
              <div className="text-xs tracking-luxe uppercase text-ink-soft mt-1">Reseñas</div>
            </div>
          </div>
        </div>

        {/* Right floating card */}
        <div className="lg:col-span-5 hidden lg:block">
          <div className="relative animate-float-slow">
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-rose-100 rounded-full blur-3xl opacity-60"></div>
            <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-gold-100 rounded-full blur-3xl opacity-50"></div>
            <div className="relative rounded-[2rem] overflow-hidden shadow-[0_30px_60px_-20px_rgba(0,0,0,0.25)]">
              <img
                src="https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Tratamiento facial AURA"
                className="w-full h-[520px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 left-8 right-8 bg-white/95 backdrop-blur-md rounded-2xl p-5 shadow-xl border border-beige-200">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gold-50 flex items-center justify-center">
                  <Sparkles size={18} className="text-gold" />
                </div>
                <div>
                  <div className="font-serif text-base text-ink">Tu transformación empieza aquí</div>
                  <div className="text-xs text-ink-soft">Belleza · Bienestar · Armonía</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
